// Mixin to handle 3rd-party OAuth function

import { i18n } from '@/i18n';

export default {
  methods: {
    signInOrSignUpWith(provider, popSteps = false) {
      if (this.$isCordova) {
        return this.signInOrSignUpWithCordova(provider, popSteps);
      }
      let that = this;
      this.loading = true;
      this.$store.dispatch('currentUser/openIdInit', { provider: provider })
        .then((result) => {
          if (!result.data || !result.data.authorization_uri) {
            console.log('invalid open id authorization data or uri');
            that.showSomethingWrongToast();
            return;
          }
          window.openIdCallbackHandler = window.openIdCallbackHandler || function(route) {
            if (route.name !== 'open-id-callback' || !route.params || !route.params.provider || !route.query) {
              console.log('unknown open id callback route');
              that.showSomethingWrongToast();
              return;
            }
            that.loading = true;
            that.$store.dispatch('currentUser/openIdCallback', { provider: route.params.provider, query: route.query })
              .then(() => {
                if (!popSteps) {
                  that.navigatorResetMain({ pageParamsAfterLoad: that.pageParamsAfterLogin } || {});
                } else {
                  that.navigatorPop({steps: popSteps});
                }
                that.setupPushNotification();
              }).catch((error) => {
                console.log(error);
                that.showSomethingWrongToast();
              }).finally(() => {
                that.loading = false;
              });
          };
          window.open(result.data.authorization_uri, 'openid', 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no');
        }).catch((error) => {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
    signInOrSignUpWithCordova(provider, popSteps = false) {
      if (!this.$isCordova) { return; }
      let that = this;
      this.loading = true;
      if (provider === 'Google') {
        if (this.$ons.platform.isIOS() || this.$ons.platform.isIPadOS()) { provider = 'Google_iOS'; }
        const promise = new Promise((resolve, reject) => {
          window.plugins.googleplus.login(
            {
              'scopes': 'email profile',
              'webClientId': '801250347648-avf782a7ln7mtvbue101q9am76f3l5av.apps.googleusercontent.com',
              // 'offline': true,
            },
            function (obj) {
              resolve(obj);
            },
            function (msg) {
              reject(msg);
            }
          );
        }).then((result) => {
          return that.$store.dispatch('currentUser/idTokenExchange', { provider: provider, idToken: result.idToken });
        }).then(() => {
          if (!popSteps) {
            that.navigatorResetMain({ pageParamsAfterLoad: that.pageParamsAfterLogin } || {});
          } else {
            that.navigatorPop({steps: popSteps});
          }
          that.setupPushNotification();
        }).catch((error) => {
          console.log(error);
          that.showSomethingWrongToast(i18n.t("messages.google_sso_error"));
        }).finally(() => {
          this.loading = false;
        });
      } else if (provider === 'Facebook') {
        const promise = new Promise((resolve, reject) => {
          window.facebookConnectPlugin.login(
            ['email', 'public_profile'],
            function (obj) {
              resolve(obj);
            },
            function (msg) {
              reject(msg);
            }
          );
        }).then((result) => {
          return that.$store.dispatch('currentUser/idTokenExchange', { provider: provider, idToken: result.authResponse.accessToken });
        }).then(() => {
          if (!popSteps) {
            that.navigatorResetMain({ pageParamsAfterLoad: that.pageParamsAfterLogin } || {});
          } else {
            that.navigatorPop({steps: popSteps});
          }
          that.setupPushNotification();
        }).catch((error) => {
          console.log(error);
          that.showSomethingWrongToast(i18n.t("messages.fb_sso_error"));
        }).finally(() => {
          this.loading = false;
        });
      } else if (provider === 'Apple') {
        const promise = new Promise((resolve, reject) => {
          window.cordova.plugins.SignInWithApple.signin(
            { requestedScopes: [1] }, // 1: email
            function(obj){
              resolve(obj);
            },
            function(err){
              reject(err);
            }
          )
        }).then((result) => {
          return that.$store.dispatch('currentUser/idTokenExchange', { provider: provider, idToken: result.identityToken });
        }).then(() => {
          if (!popSteps) {
            that.navigatorResetMain({ pageParamsAfterLoad: that.pageParamsAfterLogin } || {});
          } else {
            that.navigatorPop({steps: popSteps});
          }
          that.setupPushNotification();
        }).catch((error) => {
          console.log(error);
          that.showSomethingWrongToast(i18n.t("messages.apple_sso_error"));
        }).finally(() => {
          this.loading = false;
        });
      } else {
        console.log('unknown auth provider');
        this.showSomethingWrongToast();
        this.loading = false;
      }
    },
  },
};
